export default {
	boldText: {
		fontWeight: 600,
		fontSize: 14,
	},
	subBoldText: {
		fontSize: 13,
	},
};
